import {
  BaselineCandidatePackage,
  BaselinePackage,
  GemfuryPackage,
  Package,
  RolloutCandidate,
} from '@instabox/lockers-update-common/types'

export const isPackageInBaseline = (currentBaselinePackages: Package[], packageName: string): boolean =>
  !!currentBaselinePackages.find(({ name }) => packageName === name)

export const getPackageVersionInBaseline = (currentBaselinePackages: Package[], packageName: string): string =>
  currentBaselinePackages.find(({ name }) => packageName === name)?.version || ''

export const filterPackagesInBaseline = (
  currentBaselinePackages: Package[],
  allPackages: GemfuryPackage[]
): BaselinePackage[] =>
  allPackages
    .filter(({ name }) => isPackageInBaseline(currentBaselinePackages, name))
    .map((pkg) => ({ ...pkg, selectedVersion: getPackageVersionInBaseline(currentBaselinePackages, pkg.name) }))

export const filterPackagesNotInBaseline = (
  currentBaselinePackages: Package[],
  allPackages: GemfuryPackage[]
): BaselinePackage[] =>
  allPackages
    .filter(({ name }) => !isPackageInBaseline(currentBaselinePackages, name))
    .map((pkg) => ({ ...pkg, selectedVersion: '' }))

export const sortPackages = (
  a: BaselinePackage | BaselineCandidatePackage,
  b: BaselinePackage | BaselineCandidatePackage
) => (a.name > b.name ? 1 : -1)

export const prepBaselineCandidate = (pkgs: BaselinePackage[]): RolloutCandidate => ({
  isBaseline: true,
  packages: pkgs.map(({ name, selectedVersion: version }) => ({ name, version })),
  targetDevices: [],
})
